import { Zap, Sun, Shield, Home, FileCheck, Volume2 } from 'lucide-react';
import { useSlideIn } from '../hooks/useSlideIn';

const servicesData = [
  {
    id: 1,
    iconName: 'Zap',
    title: 'Elektroinstallation',
    description: 'Umfassender Kundendienst für Privat- und Industriekunden. Von der einzelnen Steckdose bis zu komplexen Anlagen.',
    features: 'Neuinstallationen • Sanierungen • Erweiterungen',
  },
  {
    id: 2,
    iconName: 'Sun',
    title: 'Photovoltaik',
    description: 'Maßgeschneiderte Photovoltaikanlagen für effiziente und zuverlässige Nutzung erneuerbarer Energien.',
    features: 'Planung • Installation • Inbetriebnahme',
  },
  {
    id: 3,
    iconName: 'Shield',
    title: 'Brandmeldeanlagen',
    description: 'Normgerechte Brandmeldeanlagen nach DIN 14675 für Gewerbe, öffentliche Gebäude und Sonderbauten. Spezialisiert auf Hekatron-Systeme inkl. Aufschaltung zur Feuerwehr.',
    features: 'Projektierung • Errichtung • Wartung',
  },
  {
    id: 4,
    iconName: 'Volume2',
    title: 'Sprachalarmierungsanlagen',
    description: 'Normgerechte Sprachalarmierungsanlagen nach DIN 14675 zur gezielten und sicheren Evakuierung von Gebäuden.',
    features: 'Planung • Errichtung • Inbetriebnahme',
  },
  {
    id: 5,
    iconName: 'Home',
    title: 'Sicherheitsbeleuchtung',
    description: 'Normgerechte Sicherheits- und Notbeleuchtungsanlagen für Flucht- und Rettungswege.',
    features: 'Planung • Installation • Prüfung',
  },
  {
    id: 6,
    iconName: 'FileCheck',
    title: 'DGUV V3 Prüfungen',
    description: 'Fachgerechte Prüfungen elektrischer Anlagen und Betriebsmittel mit rechtssicherer Dokumentation.',
    features: 'Ortsveränderliche Geräte • Ortsfeste Anlagen • Maschinen',
  },
];

const iconMap = {
  Zap,
  Sun,
  Shield,
  Home,
  FileCheck,
  Volume2,
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.iconName];
  return (
    <div
      data-testid={`service-card-${service.id}`}
      className="service-card bg-white border border-zinc-200 p-8 group"
    >
      <div className="mb-6">
        {IconComponent && <IconComponent className="service-icon" strokeWidth={1.5} />}
      </div>
      <h3 className="text-xl font-bold text-neutral-900 mb-3 group-hover:text-[#E31E24] transition-colors">
        {service.title}
      </h3>
      <p className="text-neutral-600 text-sm mb-4 leading-relaxed">
        {service.description}
      </p>
      <p className="text-sm text-neutral-700">
        {service.features}
      </p>
    </div>
  );
};

export const Services = () => {
  const anim = useSlideIn();

  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#kontakt');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="leistungen" data-testid="services-section" className="py-20 md:py-32 bg-white">
      <div ref={anim.ref} className={"max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 slide-in-left" + (anim.isVisible ? " visible" : "")}>
        <div className="text-center mb-16">
          <span className="inline-block text-[#E31E24] font-semibold text-sm uppercase tracking-widest mb-4">
            Unsere Leistungen
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-neutral-900 mb-6">
            Elektrotechnik auf höchstem Niveau
          </h2>
          <p className="text-neutral-600 text-base lg:text-lg max-w-2xl mx-auto">
            Als zertifizierter Fachbetrieb bieten wir Ihnen ein breites Spektrum an Elektrodienstleistungen – 
            von der klassischen Installation bis zu innovativen Sicherheitssystemen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {servicesData.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>

        <div className="text-center bg-zinc-50 p-8 md:p-12 border border-zinc-200">
          <h3 className="text-2xl font-bold text-neutral-900 mb-4">
            Suchen Sie eine spezielle Leistung?
          </h3>
          <p className="text-neutral-600 mb-6 max-w-xl mx-auto">
            Wir beraten Sie gerne zu Ihrem individuellen Projekt. Kontaktieren Sie uns für eine kostenlose und unverbindliche Beratung.
          </p>
          <a
            href="#kontakt"
            onClick={scrollToContact}
            data-testid="services-cta"
            className="btn-primary inline-block"
          >
            Jetzt Anfrage stellen
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
